import axios from 'axios'
import csrf from '@/utils/csrf'

axios.defaults.headers.common[csrf.headerKey] = csrf.token

export default axios
